import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const useMerchantStats = (days = 30) => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ["merchantStats", days],
    async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/order/orders/merchant/me/stats?days=${days}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data;
    },
    { enabled: !!token }
  );
};

export default useMerchantStats;
